module.exports = __webpack_public_path__ + "static/img/cabinet24_5.31829f58.gif";